export default __webpack_public_path__ + "static/media/oscer-pres-vomiting.8bcc2f85.svg";